import React, { Component } from 'react';
import { Redirect, Route, NavLink, Link, Switch } from 'react-router-dom';
import superagent from 'superagent';
import ReactLoading from 'react-loading';


class Login extends Component {
    constructor(props) {
        super(props);

        this.onClickLogin = this.onClickLogin.bind(this);
        this.updateAnumber = this.updateAnumber.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.updateStudentDetails= this.updateStudentDetails.bind(this);



         this.state={
            collapse: false,
            showError: false,
            loading: false,
            loginStatus:false,
            access_token:"",
            student_data:{},
            authentication_error: false,
            valid_anumber:false,
            valid_password: false,
            validation_message:"",
            error_message:"Login failed. Please enter valid credentials.",
            anumber_error_message:"Admission number required",
            password_error_message: "password required",
            display_anumber_error:false,
            display_password_error:false,
            anumber: "",
            password: ""

         }
      }


      updateStudentDetails(studentData, loginStatus)
    {
        console.log("init details update");
        this.props.updateStudentDetails(studentData, loginStatus);
    }


    onClickLogin() {
        if(this.state.valid_anumber && this.state.valid_password)
        {
                this.setState({loading:true});
                const _this = this;
                const url = this.props.base_url +"/student/login"

                superagent
                .post(url)
                .send({admission_number:_this.state.anumber, password:_this.state.password})
                .set('Accept', 'application/json')
                .set('Content-Type', 'application/json')
                .then(function(res){
                    //res.body, res.headers, res.status
                    let error = res.body.error;
                    console.log("Response", res.body);


                    if(! error)
                    {
                        let student_details = res.body.student_details;
                        //const access_token = res.body.meta.access_token;
                        console.log("Process", "successful login");
                        _this.updateStudentDetails(student_details,true);
                    }
                    else
                    {
                        let message = res.body.message;
                        _this.setState({loading:false, authentication_error:true, error_message:message});
                    }

                })
                .catch(function(err){

                    const error_response_message = err +".\n\n Please contact system admin to allow your IP access.";
                    const msg = "Unsecured connection or Invalid SSL cerificate. Connection to the server blocked";
                    _this.setState({loading:false, authentication_error:true, error_message:msg});
                });


        }

        else
        {
            this.setState({display_anumber_error:true, display_password_error:true});

        }
      }

      updateAnumber(event) {
        event.preventDefault();

        let anumber_value = event.target.value;

        if(0 === anumber_value.length)
        {
            this.setState({anumber:anumber_value, valid_anumber:false, anumber_error_message:"Please enter admission number",display_anumber_error:true})
        }
        else
        {
            this.setState({anumber:anumber_value, valid_anumber:true, anumber_error_message:"", display_anumber_error:false})
        }

      }


      updatePassword(event) {
        event.preventDefault();

        const password_value = event.target.value;

        this.setState({password:event.target.value});

        if(0 === password_value.length)
        {
            this.setState({password:password_value, valid_password:false, password_error_message:"Please enter password", display_password_error:true})
        }
        else
        {
            this.setState({password:password_value, valid_password:true, password_error_message:"", display_password_error:false})
        }
      }


      renderLoadingProgress()
      {
          if(this.state.loading)
          {
              return(
                <div className="loading-progress">
                <div >
                    Loading, Please wait......
                    <ReactLoading className="loading-progress" type="spinningBubbles" color="#000" height="40"  />
                </div>
            </div>

              );
          }
          else{
              return null;
          }
      }

      renderAnumberError()
      {
          if(this.state.display_anumber_error && !this.state.valid_anumber)
          {
            return(<div className="error-block"><p className="validation-error">{this.state.anumber_error_message}</p></div>);
          }
          else
          {
            return null;
          }
      }

      renderPasswordError()
      {
          if(this.state.display_password_error && !this.state.valid_password)
          {
            return(<div className="error-block"><p className="validation-error">{this.state.password_error_message}</p></div>);
          }
          else
          {
            return null;
          }
      }

      renderErrorMessage()
      {
          if(this.state.authentication_error && !this.state.loading)
          {
              return(
                <div className="loading-progress">
                    <div className="error-message">
                        <p>{this.state.error_message}</p>
                    </div>
                </div>
              );
          }
          else
          {
            return null;
          }

      }



  render() {

    const _this = this;

    if(_this.props.loginStatus)
      {
        return(<Redirect to="/student_ui"/>);
      }

    return (

        <form className="form login-form" method="" action="">

                  <div className="card card-login">


                    <div margin-top="-60px" className="card-header-login card-header card-header-rose text-center ">
                        <div style={{top:0}} className="cont-center">
                            <Link  to="/"><img src="/img/logotuc.png" alt="logo" height="120"/></Link>
                        </div>

                        <h4 className="card-title">ETTI - Student Login </h4>
                        {this.renderLoadingProgress()}
                        {this.renderErrorMessage()}
                    </div>
                    <div className="card-body ">


                      <span className="bmd-form-group">
                        <div className="input-group">
                        <div className="input-group-prepend">
                            <span className="input-group-text">
                          
                            </span>
                          </div>
                          
                          <input type="text" onChange={_this.updateAnumber.bind(_this)} disabled={this.state.loading} className="form-control" placeholder="Admission Number"/>
                        </div>
                        {this.renderAnumberError()}
                      </span>
                      <span className="bmd-form-group">
                        <div className="input-group">
                          <div className="input-group-prepend">
                            <span className="input-group-text">
                              <i className="material-icons">lock_outline</i>
                            </span>
                          </div>
                          <input type="password" onChange={_this.updatePassword.bind(_this)} disabled={this.state.loading} className="form-control" placeholder="Password..."/>
                        </div>
                        {this.renderPasswordError()}
                      </span>
                    </div>
                    <div className="card-footer justify-content-center">
                      <button type="submit" onClick={_this.onClickLogin.bind(_this)} onTap={_this.onClickLogin.bind(_this)} disabled={this.state.loading}  className="btn btn-green">Login<div className="ripple-container"></div></button>
                    </div>

                    <div className="card-footer justify-content-center">

                      <Link to="/student/forgotpassword" >Forgot Password ?</Link>
                    </div>

                    <div margin-bottom="10px" className="card-footer justify-content-center">

                      Not yet registered?  <Link to="/student/register" >  Create Account</Link>
                    </div>

                  </div>
        </form>



    );
  }
}

export default Login;
